import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '.';
import { IBaseResponse, IListItem, IOpo, IOpoForList, IOptnRegion, IState } from '../models';

export interface IOpoListResponse {
    data: {
        success: boolean,
        message: string,
        results: IOpoForList[]
    }
}

export interface IOpoResponse {
    data: {
        success: boolean,
        message: string,
        results: IOpo
    }
}

export interface IOpoLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            stateList: IState[],
            opoPositionList: IListItem[],
            phoneTypeList: IListItem[],
            optnRegionList: IOptnRegion[]
        }
    }
}

export interface IOpoAddResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export interface IOpoCheckForExistingAliasResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export interface IOpoAddUpdateRequest {
    optnAlias: string,
    optnName: string,
    nkrAlias: string,
    nkrName: string,
    legalName: string,
    address: string,
    city: string,
    stateId: number,
    postalCode: string,
    opoRegion: number,
    executiveDirector: string,
    medicalDirector: string,
    phoneNumber: string,
    website: string,
    achRoutingNumber: string,
    achAccountNumber: string,
    isActive: boolean
}

export const ActionCreators = {
    getList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoListResponse> => {
        let options = {
            url: `${__API__}/admin/opo`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getById: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoResponse> => {
        let options = {
            url: `${__API__}/admin/opo/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getByUserId: (userId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoResponse> => {
        let options = {
            url: `${__API__}/admin/opo/by-user-id?userId=${userId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getLookupData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoLookupDataResponse> => {
        let options = {
            url: `${__API__}/admin/opo/lookup-data`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    add: (request: IOpoAddUpdateRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoAddResponse> => {
        let options = {
            url: `${__API__}/admin/opo`,
            data: {
                ...request
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    update: (id: number, isOpo: boolean, request: IOpoAddUpdateRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/opo/${id}?isOpo=${isOpo}`,
            data: {
                ...request
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },

    delete: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/opo/${id}`
        };

        try {
            return await dispatch(AuthActionCreators.apiDelete(options));
        } catch (error) {
            throw error;
        }
    },

    checkForExistingAlias: (id: number, alias: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IOpoCheckForExistingAliasResponse> => {
        let options = {
            url: `${__API__}/admin/opo/id=${id}&alias=${alias}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
}

export interface IOpoState {
}

var initialState: IOpoState = {
};

const createReducer = (initialState: IOpoState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
